import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "product_lst_area type_default" }
const _hoisted_5 = { class: "prod_info_bx" }
const _hoisted_6 = { class: "prod_value" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("총 ")
const _hoisted_8 = { class: "value_txt" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("개 상품")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_navigator_component = _resolveComponent("navigator-component")
  const _component_sort_option_component = _resolveComponent("sort-option-component")
  const _component_product_list_component = _resolveComponent("product-list-component")
  const _component_to_top_component = _resolveComponent("to-top-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_navigator_component, {
        "navigator-code": "product",
        hashtagList: _ctx.hashtagList,
        onChangeHashtagOption: _ctx.changeHashtagOption
      }, null, 8, ["hashtagList", "onChangeHashtagOption"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("em", _hoisted_8, _toDisplayString(_ctx.totalCount), 1),
            _hoisted_9
          ]),
          _createVNode(_component_sort_option_component, { onLoadNewItem: _ctx.loadNewProduct }, null, 8, ["onLoadNewItem"])
        ]),
        _createVNode(_component_product_list_component, { products: _ctx.products }, null, 8, ["products"])
      ])
    ]),
    _createVNode(_component_to_top_component)
  ], 2))
}